angular.module('impactx.indexqueue').service("IndexQueueProgressService", [
    'WebSocketService',
    IndexQueueProgressService]);

function IndexQueueProgressService(WebSocketService) {
    var init = function () {
        return WebSocketService.init("themeworld/indexing");
    };

    var send = WebSocketService.send;
    var close = WebSocketService.close;
    var getLastMessage = WebSocketService.getLastMessage;

    return {
        init: init,
        send: send,
        getLastMessage: getLastMessage,
        close: close
    };
}

